import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.black,
  errorColor: colors.warningRed
};
export default book;